import React from 'react';
import cx from 'classnames';
import { useHistory, useLocation } from 'react-router-dom';
import { Button, DefaultPopup, Label } from '@atlas/ui';
import { useHidePopupSignUpDelay } from 'hooks/useHidePopupSignUpDelay';
import { useSetNextShowPopupSignUpDelay } from 'hooks/useSetNextShowPopupSignUpDelay';

const EmailVerification = () => {
  const history = useHistory();
  const { search, pathname } = useLocation();
  const searchParams = new URLSearchParams(search);
  const isSuccessful = searchParams.get('isSuccessful') === 'true';

  useHidePopupSignUpDelay();
  useSetNextShowPopupSignUpDelay();

  const className = cx(['popup__emailVerification', isSuccessful && 'verification__successful']);

  return (
    <DefaultPopup
      onClose={() => history.push(pathname)}
      headerTitle={
        isSuccessful ? 'verification_successful_title' : 'verification_unsuccessful_title'
      }
      className={className}
    >
      <div className="popup__content">
        <Label
          message={
            isSuccessful ? 'verification_successful_message' : 'verification_unsuccessful_message'
          }
          className="popup__title"
        />
      </div>

      <div className="popup__footer">
        <div className="popup__buttons">
          <Button onClick={() => history.push(pathname)}>
            <Label message="ok" />
          </Button>
        </div>
      </div>
    </DefaultPopup>
  );
};

export default EmailVerification;
